import { Box, Checkbox, TextInput } from '@mantine/core';
import { CustomFilter } from '../api/common';
import { IconSearch } from '@tabler/icons-react';

export type UserFilters = {
  username?: CustomFilter;
  $showDeleted?: string;
};

export const UserFilter = ({
  onChange,
}: {
  onChange: (k: string, v: CustomFilter) => void;
}) => {
  return (
    <Box mb="lg">
      <TextInput
        leftSection={<IconSearch />}
        label="Search usernames"
        onBlur={(e) => {
          const value = e.target.value;
          onChange('username', value ? { $partial: value } : '');
        }}
        onKeyUp={(e) => {
          const value = (e.target as any)?.value;
          if (e.key === 'Enter') {
            onChange('username', value ? { $partial: value } : '');
          }
        }}
      />
      <Checkbox
        mt="lg"
        label="Show deleted"
        onChange={(e) =>
          onChange('$showDeleted', e.target.checked ? 'true' : '')
        }
      />
    </Box>
  );
};
